import {ReduxStateType} from '../store';

export const selectBalanceSheetReducer = (state: ReduxStateType) =>
  state.balanceSheet;
